import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  registerKayit,
  getSirketlerKayit,
  getIllerKayit,
  getIlcelerKayit,
  sendKayitSms,
  verifyKayitSms,
  login,
} from "../services/api";
import {
  TextField,
 
  Button,
  Typography,
  Box,
  Paper,
  CircularProgress,
  Link,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  Fade,
  Zoom,
  Alert,
  Container,
  Card,
  CardContent,
  CardActionArea,
} from "@mui/material";
import {
  Business,
  Person,
  LocationOn,
  ArrowBack,
  Phone,
  Home,
  Badge,
} from "@mui/icons-material";
import logo from "../assets/logos/logo.png";
import "./Register.css";

const RegisterKayit = () => {
  const navigate = useNavigate();
  const { setToken, setUser } = useContext(AuthContext);
  const [accountType, setAccountType] = useState(null); // 'E' veya 'H'
  const [activeStep, setActiveStep] = useState(0);

  const [sirketler, setSirketler] = useState([]);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);

  const [formData, setFormData] = useState({
    ENTEGRE_SIRKET_ID: "",
    SIRKET_MI: "",
    URETICI_SIRKET_ADI: "",
    URETICI_VERGI_DAIRESI: "",
    URETICI_VERGI_NO: "",
    IL_ID: "",
    ILCE_ID: "",
    ADRES: "",
    SORUMLU_ADI1: "",
    SORUMLU_ADI2: "",
    CEP1: "",
    SORUMLU1_TCKN: "",
  });

  const [loading, setLoading] = useState(false);
  const [globalError, setGlobalError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [showSmsForm, setShowSmsForm] = useState(false);
  const [smsCode, setSmsCode] = useState("");
  const [smsError, setSmsError] = useState("");
  const [phoneForVerification, setPhoneForVerification] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // Hesap tipine göre adımları belirle
  const steps =
    accountType === "E"
      ? [
          { label: "Şirket Seç", icon: <Business /> },
          { label: "Firma Bilgileri", icon: <Badge /> },
          { label: "Adres", icon: <LocationOn /> },
          { label: "Yetkili Kişi", icon: <Person /> },
        ]
      : [
          { label: "Şirket Seç", icon: <Business /> },
          { label: "Adres", icon: <LocationOn /> },
          { label: "Kişi Bilgileri", icon: <Person /> },
        ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [sirketlerRes, illerRes] = await Promise.all([
          getSirketlerKayit(),
          getIllerKayit(),
        ]);
        setSirketler(sirketlerRes.data?.data || []);
        setIller(illerRes.data?.data || []);
      } catch (err) {
        setGlobalError("Gerekli veriler yüklenirken bir hata oluştu.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (formData.IL_ID) {
      const fetchIlceler = async () => {
        try {
          const response = await getIlcelerKayit(formData.IL_ID);
          setIlceler(response.data?.data || []);
        } catch (err) {
          setGlobalError("İlçeler yüklenirken bir hata oluştu.");
        }
      };
      fetchIlceler();
    } else {
      setIlceler([]);
    }
  }, [formData.IL_ID]);

  const handleAccountTypeSelect = (type) => {
    setAccountType(type);
    setFormData((prev) => ({ ...prev, SIRKET_MI: type }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const newState = { ...prev, [name]: value };
      if (name === "IL_ID") newState.ILCE_ID = "";
      console.log("Güncellenen formData:", newState);
      return newState;
    });

    if (fieldErrors[name]) {
      setFieldErrors((prev) => ({ ...prev, [name]: "" }));
    }
    setGlobalError("");
  };

  const validateStep = () => {
    const errors = {};
    const {
      ENTEGRE_SIRKET_ID,
      URETICI_SIRKET_ADI,
      URETICI_VERGI_DAIRESI,
      URETICI_VERGI_NO,
      IL_ID,
      ILCE_ID,
      ADRES,
      SORUMLU_ADI1,
      SORUMLU_ADI2,
      CEP1,
      SORUMLU1_TCKN,
    } = formData;

    if (accountType === "E") {
      // Kurumsal
      switch (activeStep) {
        case 0:
          if (!ENTEGRE_SIRKET_ID)
            errors.ENTEGRE_SIRKET_ID = "Şirket seçimi zorunludur.";
          break;
        case 1:
          if (!URETICI_SIRKET_ADI.trim())
            errors.URETICI_SIRKET_ADI = "Şirket adı zorunludur.";
          if (!URETICI_VERGI_DAIRESI.trim())
            errors.URETICI_VERGI_DAIRESI = "Vergi dairesi zorunludur.";
          if (!/^[0-9]{10,11}$/.test(URETICI_VERGI_NO))
            errors.URETICI_VERGI_NO =
              "Vergi no 10 veya 11 haneli sayı olmalıdır.";
          break;
        case 2:
          if (!IL_ID) errors.IL_ID = "İl seçimi zorunludur.";
          if (!ILCE_ID) errors.ILCE_ID = "İlçe seçimi zorunludur.";
          if (!ADRES.trim() || ADRES.length < 10)
            errors.ADRES = "Geçerli bir adres girin (en az 10 karakter).";
          break;
        case 3:
          if (!SORUMLU_ADI1.trim())
            errors.SORUMLU_ADI1 = "Yetkili adı zorunludur.";
          if (!SORUMLU_ADI2.trim())
            errors.SORUMLU_ADI2 = "Yetkili soyadı zorunludur.";
          if (!/^[0-9]{11}$/.test(SORUMLU1_TCKN.trim()))
            errors.SORUMLU1_TCKN = "TCKN 11 haneli sayı olmalıdır.";
          if (!/^0?5[0-9]{9}$/.test(CEP1))
            errors.CEP1 = "Telefon 05xxxxxxxxx formatında olmalıdır.";
          break;
      }
    } else {
      // Bireysel
      switch (activeStep) {
        case 0:
          if (!ENTEGRE_SIRKET_ID)
            errors.ENTEGRE_SIRKET_ID = "Şirket seçimi zorunludur.";
          break;
        case 1:
          if (!IL_ID) errors.IL_ID = "İl seçimi zorunludur.";
          if (!ILCE_ID) errors.ILCE_ID = "İlçe seçimi zorunludur.";
          if (!ADRES.trim() || ADRES.length < 10)
            errors.ADRES = "Geçerli bir adres girin (en az 10 karakter).";
          break;
        case 2:
          if (!SORUMLU_ADI1.trim()) errors.SORUMLU_ADI1 = "Adınız zorunludur.";
          if (!SORUMLU_ADI2.trim())
            errors.SORUMLU_ADI2 = "Soyadınız zorunludur.";
          if (!/^[0-9]{11}$/.test(SORUMLU1_TCKN.trim()))
            errors.SORUMLU1_TCKN = "TCKN 11 haneli sayı olmalıdır.";
          if (!/^0?5[0-9]{9}$/.test(CEP1))
            errors.CEP1 = "Telefon 05xxxxxxxxx formatında olmalıdır.";
          break;
      }
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleSendSms = async () => {
    if (!validateStep()) return;

    // Telefonu normalize et - başında 0 varsa al, yoksa ekle
    let phone = formData.CEP1.trim();
    if (!phone.startsWith("0")) {
      phone = `0${phone}`;
    }

    setPhoneForVerification(phone);

    setLoading(true);
    try {
      console.log("SMS gönderiliyor, telefon:", phone);
      const payload = { TELEFON: phone };
      console.log("SMS payload:", payload);

      await sendKayitSms(payload);
      setShowSmsForm(true);
      setSuccessMessage("Doğrulama kodu gönderildi.");
      setGlobalError(""); // Önceki hataları temizle
    } catch (err) {
      console.error("SMS gönderme hatası:", err);
      console.error("Hata detayı:", err.response?.data);

      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        "SMS gönderilemedi. Lütfen tekrar deneyin.";

      setGlobalError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSmsSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{6}$/.test(smsCode)) {
      setSmsError("Kod 6 haneli olmalıdır.");
      return;
    }
    setLoading(true);
    try {
      console.log("SMS doğrulama yapılıyor:", {
        telefon: phoneForVerification,
        kod: smsCode,
      });

      await verifyKayitSms({
        TELEFON: phoneForVerification,
        KOD: smsCode,
      });

      const payload = {
        ENTEGRE_SIRKET_ID: Number(formData.ENTEGRE_SIRKET_ID),
        SIRKET_MI: formData.SIRKET_MI,
        URETICI_ADI: `${formData.SORUMLU_ADI1} ${formData.SORUMLU_ADI2}`,
        URETICI_NO: formData.SORUMLU1_TCKN,
        IL_ID: Number(formData.IL_ID),
        ILCE_ID: Number(formData.ILCE_ID),
        ADRES: formData.ADRES,
        SORUMLU_ADI1: formData.SORUMLU_ADI1,
        SORUMLU_ADI2: formData.SORUMLU_ADI2,
        CEP1: phoneForVerification.startsWith("0")
          ? phoneForVerification.substring(1)
          : phoneForVerification,
        SORUMLU1_TCKN: formData.SORUMLU1_TCKN,
        UYRUK_ULKE_ID: 168,
      };

      if (accountType === "E") {
        payload.URETICI_SIRKET_ADI = formData.URETICI_SIRKET_ADI;
        payload.URETICI_VERGI_DAIRESI = formData.URETICI_VERGI_DAIRESI;
        payload.URETICI_VERGI_NO = formData.URETICI_VERGI_NO;
      }

      console.log("Gönderilen payload:", payload);
      const registerResponse = await registerKayit(payload);

      console.log("Kayıt response:", registerResponse);
      console.log("Kayıt response data:", registerResponse.data);

      // Backend'den başarılı yanıt kontrolü - Data büyük harfle
      if (
        registerResponse.data?.Data === "OK" ||
        registerResponse.data?.data === "OK" ||
        registerResponse.data?.status === true
      ) {
        setSuccessMessage("Kayıt başarılı! Giriş yapılıyor...");

        // Otomatik giriş yap
        const phoneForLogin = phoneForVerification.startsWith("0")
          ? phoneForVerification.substring(1)
          : phoneForVerification;

        try {
          const loginResponse = await login({
            TELEFON: phoneForLogin,
            SIFRE: formData.SORUMLU1_TCKN, // İlk şifre TCKN
          });

          console.log("Login response:", loginResponse);

          if (loginResponse.data?.token) {
            setToken(loginResponse.data.token);
            setUser(loginResponse.data.user);

            setSuccessMessage(
              "Giriş başarılı! Ana sayfaya yönlendiriliyorsunuz..."
            );
            setTimeout(() => navigate("/"), 1500);
          } else {
            setSuccessMessage(
              "Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz..."
            );
            setTimeout(() => navigate("/login"), 2000);
          }
        } catch (loginErr) {
          console.error("Otomatik giriş hatası:", loginErr);
          setSuccessMessage(
            "Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz..."
          );
          setTimeout(() => navigate("/login"), 2000);
        }
      } else {
        throw new Error(
          registerResponse.data?.message || "Kayıt işlemi başarısız."
        );
      }
    } catch (err) {
      console.error("Kayıt/Giriş hatası:", err);
      console.error("Hata detayı:", err.response?.data);

      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        "İşlem başarısız. Lütfen tekrar deneyin.";

      setGlobalError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const getStepContent = (step) => {
    const commonProps = (name) => ({
      name,
      value: formData[name],
      onChange: handleChange,
      fullWidth: true,
      error: !!fieldErrors[name],
      helperText: fieldErrors[name] || "",
      variant: "outlined",
      margin: "normal",
    });

    if (accountType === "E") {
      // Kurumsal
      switch (step) {
        case 0:
          return (
            <FormControl
              fullWidth
              margin="normal"
              error={!!fieldErrors.ENTEGRE_SIRKET_ID}
            >
              <InputLabel>Entegre Şirket *</InputLabel>
              <Select
                name="ENTEGRE_SIRKET_ID"
                value={formData.ENTEGRE_SIRKET_ID}
                onChange={handleChange}
                label="Entegre Şirket *"
              >
                {sirketler.map((s) => (
                  <MenuItem
                    key={`sirket-${s.ENTEGRE_SIRKET_ID}`}
                    value={s.ENTEGRE_SIRKET_ID}
                  >
                    {s.SIRKET_ADI}
                  </MenuItem>
                ))}
              </Select>
              {fieldErrors.ENTEGRE_SIRKET_ID && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 2, mt: 0.5 }}
                >
                  {fieldErrors.ENTEGRE_SIRKET_ID}
                </Typography>
              )}
            </FormControl>
          );
        case 1:
          return (
            <>
              <TextField
                {...commonProps("URETICI_SIRKET_ADI")}
                label="Şirket Adı *"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Business />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                {...commonProps("URETICI_VERGI_DAIRESI")}
                label="Vergi Dairesi *"
              />
              <TextField
                {...commonProps("URETICI_VERGI_NO")}
                label="Vergi Numarası *"
                inputProps={{ maxLength: 11 }}
              />
            </>
          );
        case 2:
          return (
            <>
              <FormControl
                fullWidth
                margin="normal"
                error={!!fieldErrors.IL_ID}
              >
                <InputLabel>İl *</InputLabel>
                <Select
                  name="IL_ID"
                  value={formData.IL_ID}
                  onChange={handleChange}
                  label="İl *"
                >
                  {iller.map((il) => (
                    <MenuItem key={`il-${il.IL_ID}`} value={il.IL_ID}>
                      {il.IL_ADI}
                    </MenuItem>
                  ))}
                </Select>
                {fieldErrors.IL_ID && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ ml: 2, mt: 0.5 }}
                  >
                    {fieldErrors.IL_ID}
                  </Typography>
                )}
              </FormControl>
              <FormControl
                fullWidth
                margin="normal"
                error={!!fieldErrors.ILCE_ID}
                disabled={!formData.IL_ID}
              >
                <InputLabel>İlçe *</InputLabel>
                <Select
                  name="ILCE_ID"
                  value={formData.ILCE_ID}
                  onChange={handleChange}
                  label="İlçe *"
                >
                  {ilceler.map((ilce) => (
                    <MenuItem key={`ilce-${ilce.ILCE_ID}`} value={ilce.ILCE_ID}>
                      {ilce.ILCE_ADI}
                    </MenuItem>
                  ))}
                </Select>
                {fieldErrors.ILCE_ID && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ ml: 2, mt: 0.5 }}
                  >
                    {fieldErrors.ILCE_ID}
                  </Typography>
                )}
              </FormControl>
              <TextField
                {...commonProps("ADRES")}
                label="Açık Adres *"
                multiline
                rows={3}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Home />
                    </InputAdornment>
                  ),
                }}
              />
            </>
          );
        case 3:
          return (
            <>
              <TextField
                {...commonProps("SORUMLU_ADI1")}
                label="Yetkili Adı *"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                {...commonProps("SORUMLU_ADI2")}
                label="Yetkili Soyadı *"
              />
              <TextField
                {...commonProps("SORUMLU1_TCKN")}
                label="Yetkili TCKN *"
                inputProps={{ maxLength: 11 }}
              />
              <TextField
                {...commonProps("CEP1")}
                label="Cep Telefonu *"
                placeholder="05XXXXXXXXX"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone />
                    </InputAdornment>
                  ),
                }}
              />
            </>
          );
      }
    } else {
      // Bireysel
      switch (step) {
        case 0:
          return (
            <FormControl
              fullWidth
              margin="normal"
              error={!!fieldErrors.ENTEGRE_SIRKET_ID}
            >
              <InputLabel>Entegre Şirket *</InputLabel>
              <Select
                name="ENTEGRE_SIRKET_ID"
                value={formData.ENTEGRE_SIRKET_ID}
                onChange={handleChange}
                label="Entegre Şirket *"
              >
                {sirketler.map((s) => (
                  <MenuItem
                    key={`bireysel-sirket-${s.ENTEGRE_SIRKET_ID}`}
                    value={s.ENTEGRE_SIRKET_ID}
                  >
                    {s.SIRKET_ADI}
                  </MenuItem>
                ))}
              </Select>
              {fieldErrors.ENTEGRE_SIRKET_ID && (
                <Typography
                  variant="caption"
                  color="error"
                  sx={{ ml: 2, mt: 0.5 }}
                >
                  {fieldErrors.ENTEGRE_SIRKET_ID}
                </Typography>
              )}
            </FormControl>
          );
        case 1:
          return (
            <>
              <FormControl
                fullWidth
                margin="normal"
                error={!!fieldErrors.IL_ID}
              >
                <InputLabel>İl *</InputLabel>
                <Select
                  name="IL_ID"
                  value={formData.IL_ID}
                  onChange={handleChange}
                  label="İl *"
                >
                  {iller.map((il) => (
                    <MenuItem key={`bireysel-il-${il.IL_ID}`} value={il.IL_ID}>
                      {il.IL_ADI}
                    </MenuItem>
                  ))}
                </Select>
                {fieldErrors.IL_ID && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ ml: 2, mt: 0.5 }}
                  >
                    {fieldErrors.IL_ID}
                  </Typography>
                )}
              </FormControl>
              <FormControl
                fullWidth
                margin="normal"
                error={!!fieldErrors.ILCE_ID}
                disabled={!formData.IL_ID}
              >
                <InputLabel>İlçe *</InputLabel>
                <Select
                  name="ILCE_ID"
                  value={formData.ILCE_ID}
                  onChange={handleChange}
                  label="İlçe *"
                >
                  {ilceler.map((ilce) => (
                    <MenuItem
                      key={`bireysel-ilce-${ilce.ILCE_ID}`}
                      value={ilce.ILCE_ID}
                    >
                      {ilce.ILCE_ADI}
                    </MenuItem>
                  ))}
                </Select>
                {fieldErrors.ILCE_ID && (
                  <Typography
                    variant="caption"
                    color="error"
                    sx={{ ml: 2, mt: 0.5 }}
                  >
                    {fieldErrors.ILCE_ID}
                  </Typography>
                )}
              </FormControl>
              <TextField
                {...commonProps("ADRES")}
                label="Açık Adres *"
                multiline
                rows={3}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Home />
                    </InputAdornment>
                  ),
                }}
              />
            </>
          );
        case 2:
          return (
            <>
              <TextField
                {...commonProps("SORUMLU_ADI1")}
                label="Adınız *"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Person />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField {...commonProps("SORUMLU_ADI2")} label="Soyadınız *" />
              <TextField
                {...commonProps("SORUMLU1_TCKN")}
                label="TC Kimlik No *"
                inputProps={{ maxLength: 11 }}
              />
              <TextField
                {...commonProps("CEP1")}
                label="Cep Telefonu *"
                placeholder="05XXXXXXXXX"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Phone />
                    </InputAdornment>
                  ),
                }}
              />
            </>
          );
      }
    }
  };

  // İlk ekran: Hesap tipi seçimi
  if (!accountType) {
    return (
      <div className="register-page-container">
        <Container maxWidth="sm">
          <Paper elevation={6} sx={{ p: 4, mt: 8, borderRadius: 3 }}>
            <Box sx={{ textAlign: "center", mb: 4 }}>
              <img
                src={logo}
                alt="Logo"
                style={{ width: "150px", marginBottom: "1rem" }}
              />
              <Typography variant="h5" gutterBottom>
                Hesap Oluştur
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Kümeslerinizi takip etmek için bir hesap oluşturun.
              </Typography>
            </Box>

            <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
              Zaten bir hesabınız var mı?{" "}
              <Link
                component="button"
                variant="body2"
                onClick={() => navigate("/login")}
              >
                Giriş Yap
              </Link>
            </Typography>

            <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
              Hangi tür hesap oluşturmak istediğinizi seçin.
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Card
                elevation={3}
                sx={{
                  border: "2px solid transparent",
                  transition: "all 0.3s",
                  "&:hover": {
                    border: "2px solid #FF6B35",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardActionArea onClick={() => handleAccountTypeSelect("E")}>
                  <CardContent
                    sx={{ display: "flex", alignItems: "center", p: 3 }}
                  >
                    <Business sx={{ fontSize: 48, color: "#FF6B35", mr: 2 }} />
                    <Box>
                      <Typography variant="h6">Şirket</Typography>
                      <Typography variant="body2" color="text.secondary">
                        Şirketiniz için bir hesap oluşturun.
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>

              <Card
                elevation={3}
                sx={{
                  border: "2px solid transparent",
                  transition: "all 0.3s",
                  "&:hover": {
                    border: "2px solid #FF6B35",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardActionArea onClick={() => handleAccountTypeSelect("H")}>
                  <CardContent
                    sx={{ display: "flex", alignItems: "center", p: 3 }}
                  >
                    <Person sx={{ fontSize: 48, color: "#FF6B35", mr: 2 }} />
                    <Box>
                      <Typography variant="h6">Bireysel</Typography>
                      <Typography variant="body2" color="text.secondary">
                        Bireysel hesap oluşturun.
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Box>
          </Paper>
        </Container>
      </div>
    );
  }

  // Kayıt formu
  return (
    <div className="register-page-container">
      <Container maxWidth="sm">
        <Paper elevation={6} sx={{ p: 4, mt: 4, borderRadius: 3 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 2,
            }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{ width: "150px", marginBottom: "1rem" }}
            />
            <Typography component="h1" variant="h5">
              {showSmsForm
                ? "SMS Doğrulama"
                : accountType === "E"
                ? "Kurumsal Kayıt"
                : "Bireysel Kayıt"}
            </Typography>
          </Box>

          {globalError && (
            <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
              {globalError}
            </Alert>
          )}
          {successMessage && (
            <Alert severity="success" sx={{ width: "100%", mb: 2 }}>
              {successMessage}
            </Alert>
          )}

          {showSmsForm ? (
            <Fade in>
              <Box component="form" onSubmit={handleSmsSubmit}>
                <Typography align="center" sx={{ mb: 2 }}>
                  {phoneForVerification} numarasına gelen kodu girin.
                </Typography>
                <TextField
                  label="Doğrulama Kodu"
                  value={smsCode}
                  onChange={(e) => {
                    setSmsCode(e.target.value.replace(/\D/g, "").slice(0, 6));
                    setSmsError("");
                  }}
                  error={!!smsError}
                  helperText={smsError}
                  fullWidth
                  margin="normal"
                  inputProps={{ maxLength: 6, inputMode: "numeric" }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={loading}
                  sx={{ mt: 2 }}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Doğrula ve Kaydı Tamamla"
                  )}
                </Button>
              </Box>
            </Fade>
          ) : (
            <>
              <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 3 }}>
                {steps.map((step) => (
                  <Step key={step.label}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <Zoom in={true}>
                <Box sx={{ minHeight: 350 }}>{getStepContent(activeStep)}</Box>
              </Zoom>
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
              >
                <Button
                  color="inherit"
                  disabled={activeStep === 0 || loading}
                  onClick={handleBack}
                  startIcon={<ArrowBack />}
                >
                  Geri
                </Button>
                <Button
                  onClick={
                    activeStep === steps.length - 1 ? handleSendSms : handleNext
                  }
                  variant="contained"
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : activeStep === steps.length - 1 ? (
                    "Kod Gönder"
                  ) : (
                    "İleri"
                  )}
                </Button>
              </Box>
            </>
          )}

          <Typography align="center" sx={{ mt: 4 }}>
            Zaten bir hesabınız var mı?{" "}
            <Link
              component="button"
              variant="body2"
              onClick={() => navigate("/login")}
              disabled={loading}
            >
              Giriş Yapın
            </Link>
          </Typography>
        </Paper>
      </Container>
    </div>
  );
};

export default RegisterKayit;
